import { render, staticRenderFns } from "./SGEventos.vue?vue&type=template&id=28ded7fd&scoped=true"
import script from "./SGEventos.vue?vue&type=script&lang=js"
export * from "./SGEventos.vue?vue&type=script&lang=js"
import style0 from "./SGEventos.vue?vue&type=style&index=0&id=28ded7fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ded7fd",
  null
  
)

export default component.exports